export function firstToUpper(stringVal) {
    return stringVal.charAt(0).toUpperCase() + stringVal.slice(1);
}



// WEBPACK FOOTER //
// ./src/businessLogic/stringMethods.js